import { Clock } from 'lucide-react';
import { CLOSE_COUNTDOWN_WINDOW_MS, formatClockTime, formatCountdown } from '../../utils/requestWindow';

export function RequestsCloseNotice({ closeAtMs, nowMs }: { closeAtMs: number | null; nowMs: number }) {
  if (closeAtMs === null || nowMs >= closeAtMs) return null;

  const remainingMs = closeAtMs - nowMs;

  if (remainingMs > CLOSE_COUNTDOWN_WINDOW_MS) {
    const closeTime = formatClockTime(closeAtMs);
    return (
      <div role="status" className="flex items-center justify-center gap-2 text-sm text-gray-500 dark:text-gray-400">
        <Clock className="w-4 h-4" />
        <span>Song requests close at {closeTime}</span>
      </div>
    );
  }

  return (
    <div role="status" className="card p-4 bg-amber-50 dark:bg-amber-900/20 border-2 border-amber-200 dark:border-amber-700">
      <div className="flex items-center justify-center gap-3">
        <Clock className="w-6 h-6 text-amber-500 dark:text-amber-400" />
        <span className="text-base font-semibold text-amber-700 dark:text-amber-300">
          Song requests close in {formatCountdown(remainingMs)}. Voting stays open.
        </span>
      </div>
    </div>
  );
}
